/*
  EL LIENZO 3D DEL HERO — Cuadros Splash (8 sep 2026)

  Los cuadros que se venden, uno tras otro, girando despacio delante del
  dormitorio. Pasan solos cada N segundos y con dos flechas a mano.
  No trae ninguna librería nueva: reutiliza el generador de modelos de la
  ficha (canvas-3d.js expone window.CuadrosSplash3D) y el <model-viewer>
  que la tienda ya usa para el 3D y la realidad aumentada.

  Cómo se cuida el rendimiento y el reposo:
    · La foto del dormitorio es el estado de reposo Y el elemento LCP: se
      pinta primero y no se toca. El lienzo llega después, en un hueco libre
      del navegador (requestIdleCallback tras `load`), y aparece con un fundido.
    · Solo en escritorio (>= 990px): en el móvil el hero es bajo y el visor
      pesa ~300 KB; ahí se queda la foto.
    · Con movimiento reducido o "ahorro de datos" activados: la foto.
    · Cualquier fallo (red, modelo, visor): la foto. Nunca un hueco.
    · El siguiente cuadro se prepara en segundo plano mientras se mira el
      actual, así el cambio es instantáneo. Se guardan como mucho seis
      modelos; los más antiguos se liberan.

  De dónde salen los cuadros: Liquid escribe la lista (los elegidos a mano
  primero, luego los que rellena desde colecciones, cada uno con su
  colección). Aquí se intercalan por colección para que dos seguidos no
  sean nunca de la misma.

  El cambio entre cuadros es un fundido cruzado de dos visores alternos
  (1,4 s). La barra de progreso que el visor pinta arriba al cargar se
  anula con un slot vacío: reaparecía en cada cambio como una línea.
  Con el ratón encima el pase se detiene — estás mirando — y sigue al salir.

  El giro va a 28°/s: se percibe con claridad sin convertirse en un giro
  nervioso. Si hay que ajustarlo, se cambia aquí, no la curva.

  El tamaño: el ajuste del tema dice qué fracción del marco tiene que llenar
  el cuadro, y el radio de cámara se despeja para cada uno (ver radioPara).
  No es lo mismo que fijar un radio igual para todos: el visor encuadra la
  esfera que envuelve al modelo, y esa esfera crece con la diagonal, así que
  con un radio fijo un panorámico salía diminuto y un vertical rozaba el
  borde. El formato del cuadro decidía el tamaño; ahora lo decide el ajuste.
*/
(function () {
  var caja = document.querySelector('[data-hero-lienzo]');
  if (!caja) return;

  var media = caja.closest('.custom-hero__media');
  var hero = caja.closest('.custom-hero');
  var ES_MOVIL = window.matchMedia('(max-width: 989px)').matches;

  /* La ficha del panel nace ya pintada con el primer cuadro (Liquid). Si el
     3D no va a llegar a la pared, se esconde: un «Anadir a la cesta» bajo
     una pared vacia seria mentir (ver section-custom-hero.css). */
  function sinFicha() {
    var f = hero && hero.querySelector('[data-hero-ficha]');
    if (f) f.hidden = true;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return sinFicha();
  if (navigator.connection && navigator.connection.saveData) return sinFicha();

  /* La lista de cuadros la escribe Liquid en un <script type=json>. */
  var brutos = [];
  try {
    var nodo = caja.querySelector('[data-hero-obras]');
    brutos = nodo ? JSON.parse(nodo.textContent) : [];
  } catch (e) { brutos = []; }
  brutos = brutos.filter(function (o) { return o && o.obra; });
  if (!brutos.length) return sinFicha();

  /* Intercalado: los elegidos a mano mantienen su orden; los de colección
     se reparten en rondas (uno de cada colección, luego otro de cada...). */
  var obras = brutos.filter(function (o) { return !o.col; });
  var porCol = {}, ordenCol = [];
  brutos.forEach(function (o) {
    if (!o.col) return;
    if (!porCol[o.col]) { porCol[o.col] = []; ordenCol.push(o.col); }
    porCol[o.col].push(o);
  });
  var quedan = true;
  while (quedan) {
    quedan = false;
    ordenCol.forEach(function (c) {
      if (porCol[c].length) { obras.push(porCol[c].shift()); quedan = true; }
    });
  }

  /* Curva de giro: cinco fases para que la aceleración y la frenada sean
     progresivas. Los grados recorridos suman exactamente 360. */
  var GIRO_LENTO = 12;
  var FASES_GIRO = [
    { grados: 12, segundos: 3 },
    { grados: 20, segundos: 3 },
    { grados: 31.2, segundos: 5 },
    { grados: 20, segundos: 3 },
    { grados: 12, segundos: 4 }
  ];
  var SEGUNDOS = 18;

  /* Que fraccion del marco llena el cuadro, en %. No es el radio de camara:
     es lo que se quiere ver, y el radio se calcula para cada cuadro (ver
     radioPara). */
  var TAMANO = parseFloat(caja.dataset.tamano);
  if (!(TAMANO > 0)) TAMANO = 80;
  if (ES_MOVIL) TAMANO = Math.min(TAMANO, 68);

  var MAX_MODELOS = 6;
  var URL_VISOR =
    'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';

  function cuandoSobreTiempo(fn) {
    function luego() {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2500 });
      else setTimeout(fn, 1200);
    }
    if (document.readyState === 'complete') luego();
    else window.addEventListener('load', luego, { once: true });
  }

  function cargarVisor() {
    if (window.__cs3dMV) return window.__cs3dMV;
    window.__cs3dMV = new Promise(function (res, rej) {
      if (customElements.get('model-viewer')) return res();
      var s = document.createElement('script');
      s.type = 'module';
      s.src = URL_VISOR;
      s.onload = function () { res(); };
      s.onerror = function () { rej(new Error('no se pudo cargar el visor 3D')); };
      document.head.appendChild(s);
    });
    return window.__cs3dMV;
  }

  function traerObra(url) {
    return fetch(url, { mode: 'cors', credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('obra ' + r.status);
      var mime = (r.headers.get('content-type') || 'image/jpeg').split(';')[0];
      return r.arrayBuffer().then(function (b) {
        return { datos: new Uint8Array(b), mime: mime };
      });
    });
  }

  /* Quien dice que cuadro se esta viendo. Liquid pone uno de los dos, nunca
     los dos: el rotulo sobre la imagen (como antes) o la ficha al pie del
     panel de texto (lo normal ahora). */
  var rotulo = hero && hero.querySelector('[data-hero-rotulo]');
  var rotuloNombre = rotulo && rotulo.querySelector('[data-hero-rotulo-nombre]');
  var rotuloEnlace = rotulo && rotulo.querySelector('a');

  var ficha = hero && hero.querySelector('[data-hero-ficha]');
  var fichaNombre = ficha && ficha.querySelector('[data-hero-ficha-nombre]');
  var fichaEnlace = ficha && ficha.querySelector('[data-hero-ficha-enlace]');
  var fichaTalla = ficha && ficha.querySelector('[data-hero-ficha-talla]');
  var fichaCat = ficha && ficha.querySelector('[data-hero-ficha-cat]');
  var fichaCatEnlace = ficha && ficha.querySelector('[data-hero-ficha-cat-link]');
  var fichaPrecio = ficha && ficha.querySelector('[data-hero-ficha-precio]');
  var fav = ficha && ficha.querySelector('[data-cs-fav]');
  var cesta = ficha && ficha.querySelector('[data-hero-cesta]');
  var cestaTxt = cesta && cesta.querySelector('[data-hero-cesta-txt]');
  var TEXTOS = {
    anadir: csT('portada.hero_lienzo.anadir', 'Añadir a la cesta'),
    anadiendo: csT('portada.hero_lienzo.anadiendo', 'Añadiendo…'),
    verCesta: csT('portada.hero_lienzo.ver_cesta', 'Ver la cesta'),
    agotado: csT('portada.hero_lienzo.agotado', 'Agotado'),
    error: csT('portada.hero_lienzo.error', 'No se ha podido')
  };
  /* La raiz de la tienda en el idioma de la visita: «/» en espanol, «/en/»
     en ingles. Un «/cart» escrito a mano devolvia al cliente al espanol. */
  var RAIZ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* «60 x 45 cm» -> «60 × 45 cm». Es el titulo de la variante tal cual, sin
     inventar nada: solo el aspa tipografica en vez de la equis. */
  function tallaBonita(t) {
    if (!t) return '';
    t = String(t);
    /* Un producto sin tallas trae «Default Title» como titulo de variante:
       eso no es una medida y no pinta nada bajo el nombre del cuadro. */
    if (!/\d/.test(t)) return '';
    return t.replace(/\s*[x×X]\s*/, ' × ');
  }

  /* Se apaga, se cambia el texto con el cartel ya invisible y se vuelve a
     encender. El medio segundo de espera es para que el nombre no cambie a
     la vista mientras aun se lee el anterior. */
  function pintarNombre(o) {
    if (rotulo) {
      rotulo.classList.remove('is-visible');
      setTimeout(function () {
        if (rotuloNombre) rotuloNombre.textContent = o.nombre || '';
        if (rotuloEnlace && o.url) rotuloEnlace.setAttribute('href', o.url);
        rotulo.classList.add('is-visible');
      }, 500);
    }
    /* El primer cuadro ya lo pinto Liquid: si es este, no se toca. Ni el
       fundido (parpadearia sin motivo) ni el boton, que puede estar ya en
       «Ver la cesta» si alguien lo pulso antes de que llegara el 3D. */
    if (ficha && !ficha.hidden && fichaEnlace && o.url && fichaEnlace.getAttribute('href') === o.url) return;
    if (ficha) {
      ficha.classList.remove('is-visible');
      setTimeout(function () {
        if (fichaNombre) fichaNombre.textContent = o.nombre || '';
        if (fichaEnlace && o.url) fichaEnlace.setAttribute('href', o.url);
        if (fichaTalla) fichaTalla.textContent = tallaBonita(o.talla);
        if (fichaCat) fichaCat.textContent = o.cat || '';
        if (fichaCatEnlace) {
          fichaCatEnlace.setAttribute('href', o.catUrl || '#');
          fichaCatEnlace.setAttribute('aria-hidden', o.catUrl ? 'false' : 'true');
        }
        /* El precio viene de Liquid ya con el filtro `money`, o sea con el
           simbolo y los decimales de la tienda. Puede traer etiquetas si
           el formato de la tienda las lleva, asi que se limpia antes de
           escribirlo como texto. */
        if (fichaPrecio) fichaPrecio.textContent = (o.precio || '').replace(/<[^>]*>/g, '');
        armarFavorito(o);
        armarCesta(o);
        if (ficha.hidden) {
          ficha.hidden = false;
          /* Recien salida de `display: none` no hay estado inicial desde el
             que animar y la transicion se saltaria. Medir la fuerza. */
          void ficha.offsetWidth;
        }
        ficha.classList.add('is-visible');
      }, 500);
    }
  }

  /* EL BOTON SE REARMA CON CADA CUADRO. Es lo que impide que alguien
     anada a la cesta el cuadro anterior: al cambiar la obra, el boton
     vuelve a su estado de partida y cambia de variante. Si esa obra no
     tiene variante o esta agotada, se queda apagado en vez de mandar un
     id que no existe. */
  function armarCesta(o) {
    if (!cesta) return;
    cesta.classList.remove('esta-dentro');
    cesta.dataset.heroCesta = '';
    delete cesta.dataset.heroVer;
    if (o.variante && o.hay !== false) {
      cesta.dataset.heroCesta = String(o.variante);
      cesta.disabled = false;
      if (cestaTxt) cestaTxt.textContent = TEXTOS.anadir;
    } else {
      cesta.disabled = true;
      if (cestaTxt) cestaTxt.textContent = o.variante ? TEXTOS.agotado : TEXTOS.anadir;
    }
  }

  /* EL CORAZON CAMBIA DE CUADRO IGUAL QUE EL BOTON DE LA CESTA.
     favoritos.js atiende el clic con un solo oyente en el documento y se
     guia por `data-cs-fav`, asi que basta con cambiarle el handle. Lo que
     NO hace solo es repintarse: su repintado general se dispara con altas
     y bajas de nodos (un MutationObserver de childList), y aqui solo
     cambia un atributo. De ahi que el estado se ponga a mano, leyendo la
     lista guardada por window.csFavoritos. */
  function armarFavorito(o) {
    if (!fav) return;
    if (!o.handle) {
      fav.hidden = true;
      return;
    }
    fav.hidden = false;
    fav.dataset.csFav = o.handle;
    var puesto = !!(window.csFavoritos && window.csFavoritos.esFavorito(o.handle));
    fav.classList.toggle('is-fav', puesto);
    fav.setAttribute('aria-pressed', puesto ? 'true' : 'false');
  }

  /* TRAMPA 3 DEL PROYECTO: el punto de entrada de la API de carrito es
     `/cart/add.js`, CON el `.js`. `routes.cart_add_url` de Liquid apunta a
     `/cart/add` a secas, que devuelve una pagina, no JSON. Esto es lo
     mismo que hace asesor.js y por la misma razon. */
  /* El boton funciona desde que la pagina se pinta, antes que el pase: hasta
     que el pase arranca no hay reloj que poner a cero. */
  var alAnadir = function () {};

  function alaCesta() {
    var id = cesta && cesta.dataset.heroCesta;
    if (!id || cesta.disabled) return;
    cesta.disabled = true;
    if (cestaTxt) cestaTxt.textContent = TEXTOS.anadiendo;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cesta');
        return r.json();
      })
      .then(function () {
        cesta.classList.add('esta-dentro');
        if (cestaTxt) cestaTxt.textContent = TEXTOS.verCesta;
        /* El boton pasa a llevar a la cesta: quien acaba de meter algo casi
           siempre quiere ver que lleva. */
        cesta.dataset.heroCesta = '';
        cesta.disabled = false;
        cesta.dataset.heroVer = '1';
        contadorCesta();
        /* Y EL RELOJ DEL PASE VUELVE A CERO. Sin esto, el cuadro podia
           cambiar medio segundo despues de anadir —`armarCesta` rearma el
           boton con cada obra— y el «Anadido» no llegaba a leerse. Asi
           quedan los ocho segundos enteros, y mas si el raton sigue encima
           (con el puntero dentro de la portada el pase no avanza). */
        alAnadir();
      })
      .catch(function () {
        cesta.disabled = false;
        if (cestaTxt) cestaTxt.textContent = TEXTOS.error;
        setTimeout(function () {
          if (cestaTxt && !cesta.classList.contains('esta-dentro')) {
            cestaTxt.textContent = TEXTOS.anadir;
          }
        }, 2200);
      });
  }

  /* Se le pide a Shopify que vuelva a pintar la seccion del icono del
     carrito y se sustituye entera, como hace Dawn. No vale escribir el
     numero a mano: con el carrito vacio Dawn no dibuja la burbuja, asi que
     no hay nada que actualizar — hay que traerse el marcado nuevo. Y no se
     puede ir a `.cart-count-bubble` a ciegas: el contador de favoritos usa
     esa misma clase a proposito (trampa 17). */
  function contadorCesta() {
    fetch(RAIZ + '?sections=cart-icon-bubble', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (secciones) {
        if (!secciones || !secciones['cart-icon-bubble']) return;
        var destino = document.getElementById('cart-icon-bubble');
        if (!destino) return;
        var doc = new DOMParser().parseFromString(secciones['cart-icon-bubble'], 'text/html');
        var origen = doc.querySelector('.shopify-section');
        if (origen) destino.innerHTML = origen.innerHTML;
      })
      .catch(function () {
        /* el contador se pone al dia solo en la siguiente pagina */
      });
  }

  if (cesta) {
    cesta.addEventListener('click', function () {
      if (cesta.dataset.heroVer === '1' && !cesta.dataset.heroCesta) {
        window.location.href = RAIZ + 'cart';
        return;
      }
      alaCesta();
    });
  }

  function montar() {
    var api = window.CuadrosSplash3D;
    if (!api || !api.construirGLB) return sinFicha(); // canvas-3d.js no llegó: foto y ya

    var fondo = parseFloat(caja.dataset.profundidad) || api.PROFUNDIDAD_M;
    var modelos = {};   // índice -> url blob del GLB
    var tallas = {};    // índice -> { ancho, alto } en metros, para el encuadre
    var enCurso = {};   // índice -> promesa en vuelo (no pedir dos veces)
    var recientes = []; // índices con modelo, del más viejo al más nuevo

    function recordar(i) {
      var k = recientes.indexOf(i);
      if (k > -1) recientes.splice(k, 1);
      recientes.push(i);
    }

    /* Libera los modelos más viejos que no estén en pantalla. */
    function purgar() {
      while (recientes.length > MAX_MODELOS) {
        var viejo = recientes[0];
        if (viejo === indice || visores.some(function (v) { return v.getAttribute('src') === modelos[viejo]; })) {
          recientes.push(recientes.shift()); // en uso: pasa al final y se prueba otro
          if (recientes.every(function (i) { return i === indice || i === anteriorIndice; })) break;
          continue;
        }
        recientes.shift();
        URL.revokeObjectURL(modelos[viejo]);
        delete modelos[viejo];
      }
    }

    /* Construye (o devuelve) el modelo del cuadro i. */
    function preparar(i) {
      var o = obras[i];
      /* La talla se mide siempre, tambien si el modelo ya estaba hecho: la
         necesita radioPara para encuadrar la camara. */
      var talla = api.medirTalla(o.talla || '') || { ancho: 0.6, alto: 0.45 };
      tallas[i] = talla;
      if (modelos[i]) { recordar(i); return Promise.resolve(modelos[i]); }
      if (enCurso[i]) return enCurso[i];
      enCurso[i] = traerObra(o.obra).then(function (obra) {
        if (!/jpe?g|png/i.test(obra.mime)) throw new Error('formato no admitido: ' + obra.mime);
        var bytes = api.construirGLB(talla.ancho, talla.alto, fondo, obra.datos, obra.mime);
        modelos[i] = URL.createObjectURL(new Blob([bytes], { type: 'model/gltf-binary' }));
        recordar(i);
        delete enCurso[i];
        return modelos[i];
      }).catch(function (e) { delete enCurso[i]; throw e; });
      return enCurso[i];
    }

    /* EL ENCUADRE, CUADRO A CUADRO.

       El visor, en su 100%, encuadra la esfera que envuelve al modelo. Esa
       esfera crece con la DIAGONAL, no con el lado que se ve: un panoramico
       de 110x50 tiene la misma diagonal que un cuadrado de 85x85, asi que
       salia diminuto, y un vertical de 50x60 —diagonal corta— casi rozaba el
       borde. Con un porcentaje fijo para todos, el tamano lo decidia el
       formato del cuadro, no el diseno.

       Aqui se hace al reves: se pide cuanto tiene que llenar del marco
       (TAMANO) y se despeja el radio que hace falta, por alto y por ancho; el
       mayor de los dos manda, que es el que no se sale. Asi un panoramico y
       un vertical se ven igual de grandes.

       El ancho se calcula de frente (theta 0), que es cuando el cuadro es mas
       ancho en pantalla: girando solo puede estrecharse. */
    function radioPara(i) {
      var t = tallas[i];
      if (!t) return 100;
      var r = caja.getBoundingClientRect();
      if (!(r.width > 0 && r.height > 0)) return 100;
      /* El visor ajusta la esfera al lado corto del marco. */
      var corto = Math.min(r.width, r.height);
      var diagonal = Math.sqrt(t.ancho * t.ancho + t.alto * t.alto + fondo * fondo);
      if (!(diagonal > 0)) return 100;
      var parte = TAMANO / 100;
      var porAlto = (t.alto / diagonal) * corto / (parte * r.height);
      var porAncho = (t.ancho / diagonal) * corto / (parte * r.width);
      var radio = Math.max(porAlto, porAncho) * 100;
      /* Dentro de los topes del visor, y sin acercarse tanto que el cuadro
         atraviese el plano de la camara. */
      return Math.max(30, Math.min(200, radio));
    }

    function encuadrar(mv, i) {
      mv.setAttribute('camera-orbit', '-24deg 82deg ' + radioPara(i).toFixed(1) + '%');
      if (mv.jumpCameraToGoal) mv.jumpCameraToGoal();
    }

    function nuevoVisor() {
      var mv = document.createElement('model-viewer');
      mv.setAttribute('alt', '');
      mv.setAttribute('loading', 'eager');
      mv.setAttribute('reveal', 'auto');
      /* Misma luz de sala que en la ficha: el bastidor proyecta sombra y el
         lienzo tiene relieve. Sin ella el cuadro parece una pegatina. */
      /* Misma fidelidad de color que el visor de la obra: `neutral` en vez
         del `auto` de fabrica, que desatura y oscurece. Ver el comentario
         largo en canvas-3d.js. Los dos visores tienen que ensenar el mismo
         color, o el cuadro de la portada y el de la ficha no pegarian. */
      mv.setAttribute('tone-mapping', 'neutral');
      mv.setAttribute('environment-image', api.entornoSala());
      mv.setAttribute('shadow-intensity', '1.2');
      mv.setAttribute('shadow-softness', '0.8');
      /* Subido de 1,1 a 1,35 el 20 sep 2026, para que el cuadro de la
         portada no se vea mas apagado que el de la ficha, que ya va a 1,5 por
         defecto. Aqui no hay deslizador: es un adorno de la portada, no la
         pieza que se compra. */
      mv.setAttribute('exposure', '1.35');
      /* Ladeado y visto desde algo más abajo: se ve el canto y el grosor del
         bastidor, que es lo que lo hace parecer un objeto. */
      /* De partida, el encuadre automatico del visor; el de verdad lo pone
         encuadrar() en cuanto se sabe que cuadro entra y cuanto mide. */
      mv.setAttribute('camera-orbit', '-24deg 82deg 100%');
      /* Los topes llevan radio explicito. Con `auto` el visor los calcula a
         partir del modelo y recortaba el ajuste de tamano: pedir 60% se
         quedaba en el minimo que el creia bueno y el cuadro no crecia. */
      mv.setAttribute('min-camera-orbit', 'auto 60deg 25%');
      mv.setAttribute('max-camera-orbit', 'auto 100deg 200%');
      /* El `auto-rotate` se pone y se quita segun el visor este a la vista
         (ver `soloGiraElDeDelante`). Aqui NO se pone: el que entra lo
         recibe al empezar el fundido. */
      mv.setAttribute('auto-rotate-delay', '0');
      mv.setAttribute('rotation-per-second', GIRO_LENTO + 'deg');
      mv.setAttribute('camera-controls', '');
      mv.setAttribute('disable-zoom', '');
      mv.setAttribute('disable-pan', '');
      mv.setAttribute('interaction-prompt', 'none');
      /* Sin barra de progreso: el visor la pinta arriba al cargar y en cada
         cambio de cuadro asomaba como una línea sobre la foto. Un elemento
         vacío en ese slot la sustituye por nada. */
      var sinBarra = document.createElement('div');
      sinBarra.setAttribute('slot', 'progress-bar');
      mv.appendChild(sinBarra);
      mv.addEventListener('error', function (e) {
        if (window.console) console.warn('[hero-lienzo-3d] visor', e);
      });
      caja.appendChild(mv);
      return mv;
    }

    /* Espera a que un visor tenga el modelo cargado. El evento `load` lo
       despacha su bucle de render, que en una pestaña de fondo no corre;
       por eso se mira también la propiedad `loaded`. */
    function cuandoCargue(mv) {
      return new Promise(function (res) {
        var hecho = false;
        function ok() { if (hecho) return; hecho = true; clearInterval(v); res(); }
        mv.addEventListener('load', ok, { once: true });
        var v = setInterval(function () { if (mv.loaded) ok(); }, 250);
        setTimeout(ok, 20000); // tope: mejor enseñar algo que esperar eterno
      });
    }

    var visores = [nuevoVisor(), nuevoVisor()];
    var activo = 0;            // cuál de los dos visores está a la vista
    var indice = -1;           // qué cuadro se ve
    var anteriorIndice = -1;
    var cambiando = false;
    var reloj = null;
    var enPausa = false;

    /* SOLO GIRA EL QUE SE VE, Y ESTO NO ES UN DETALLE.
       Los dos visores viven a la vez en el DOM; el apagado solo lleva
       `opacity: 0`, y eso NO para a model-viewer: su IntersectionObserver
       mira si el elemento esta en pantalla, no si se ve. Con `auto-rotate`
       puesto en los dos, la tarjeta grafica pintaba DOS lienzos de 1189x594
       sesenta veces por segundo para ensenar uno. Quitandoselo al de detras,
       model-viewer deja de tener nada que redibujar y se para solo. */
    function pararCurva(mv) {
      if (!mv || !mv.__csCurva) return;
      mv.__csCurva.forEach(function (t) { clearTimeout(t); });
      mv.__csCurva = null;
    }

    function programarCurva(mv) {
      if (!mv) return;
      pararCurva(mv);
      mv.setAttribute('rotation-per-second', GIRO_LENTO + 'deg');
      mv.__csCurva = [];
      var acumulado = 0;
      FASES_GIRO.slice(1).forEach(function (fase, indice) {
        acumulado += FASES_GIRO[indice].segundos;
        mv.__csCurva.push(setTimeout(function () {
          if (mv.classList.contains('is-activo')) {
            mv.setAttribute('rotation-per-second', fase.grados + 'deg');
          }
        }, acumulado * 1000));
      });
    }

    function soloGiraElDeDelante(entra, sale) {
      if (entra) {
        entra.setAttribute('auto-rotate', '');
        programarCurva(entra);
      }
      if (!sale || sale === entra) return;
      /* Se le quita DESPUES del fundido (1,4 s), no antes: mientras se apaga
         todavia se ve, y un cuadro que se queda clavado justo al empezar a
         desaparecer se nota como un tiron. */
      setTimeout(function () {
        if (!sale.classList.contains('is-activo')) {
          sale.removeAttribute('auto-rotate');
          pararCurva(sale);
        }
      }, 1600);
    }

    function mostrar(i) {
      if (cambiando || i === indice) return Promise.resolve();
      cambiando = true;
      var entra = visores[1 - activo];
      var sale = visores[activo];
      return preparar(i)
        .then(function (src) {
          entra.setAttribute('src', src);
          return cuandoCargue(entra);
        })
        .then(function () {
          /* Con el modelo ya cargado el visor sabe cuanto mide, que es lo que
             necesita el % del radio. Y el visor que entra sigue invisible:
             el salto de camara no se ve. */
          encuadrar(entra, i);
          entra.classList.add('is-activo');
          sale.classList.remove('is-activo');
          soloGiraElDeDelante(entra, sale);
          activo = 1 - activo;
          anteriorIndice = indice;
          indice = i;
          pintarNombre(obras[i]);
          if (!caja.classList.contains('is-lista')) {
            caja.classList.add('is-lista');
            if (media) media.classList.add('is-lista');
          }
          cambiando = false;
          purgar();
          // El siguiente, listo antes de que haga falta.
          cuandoSobreTiempo(function () { preparar((i + 1) % obras.length).catch(function () {}); });
        })
        .catch(function (e) {
          cambiando = false;
          if (window.console) console.warn('[hero-lienzo-3d]', e);
          // Un cuadro fallido no para el pase: se salta.
          if (obras.length > 1) obras.splice(i, 1);
        });
    }

    function siguiente() { return mostrar((indice + 1) % obras.length); }
    function anterior() { return mostrar((indice - 1 + obras.length) % obras.length); }

    function arrancaReloj() {
      paraReloj();
      if (obras.length < 2) return;
      reloj = setInterval(function () {
        if (!enPausa && !document.hidden) siguiente();
      }, SEGUNDOS * 1000);
    }
    function paraReloj() { if (reloj) { clearInterval(reloj); reloj = null; } }
    alAnadir = arrancaReloj;

    /* Flechas. Tras tocarlas, el reloj vuelve a contar desde cero. */
    var mando = hero && hero.querySelector('[data-hero-mando]');
    if (mando && obras.length > 1) {
      mando.hidden = false;
      var bAnt = mando.querySelector('[data-hero-anterior]');
      var bSig = mando.querySelector('[data-hero-siguiente]');
      if (bAnt) bAnt.addEventListener('click', function () { enPausa = false; anterior(); arrancaReloj(); });
      if (bSig) bSig.addEventListener('click', function () { enPausa = false; siguiente(); arrancaReloj(); });
    }

    /* El modo manual empieza al pulsar el lienzo, no al pasar por encima. */
    if (hero) {
      hero.addEventListener('pointerdown', function (evento) {
        var visor = evento.target && evento.target.closest
          ? evento.target.closest('model-viewer')
          : null;
        if (!visor) return;
        if (enPausa) {
          enPausa = false;
          visor.setAttribute('auto-rotate', '');
          programarCurva(visor);
          arrancaReloj();
        } else {
          enPausa = true;
          paraReloj();
          visor.removeAttribute('auto-rotate');
        }
      });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) paraReloj(); else arrancaReloj();
    });

    /* El alto del hero sale de su ancho y el ancho es 75vw: al cambiar la ventana
       cambia la forma del marco, y con ella el encuadre. Sin esto, quien abre
       a media pantalla y maximiza se queda con el cuadro mal medido. */
    var relojMedida = null;
    window.addEventListener('resize', function () {
      if (relojMedida) clearTimeout(relojMedida);
      relojMedida = setTimeout(function () {
        if (indice > -1) encuadrar(visores[activo], indice);
      }, 250);
    });

    if (media) media.classList.add('tiene-lienzo');
    cargarVisor()
      .then(function () { return mostrar(0); })
      .then(function () {
        /* El primero fallo y se salto: la ficha dice un cuadro que no esta en
           la pared. Fuera hasta que llegue el siguiente (pintarNombre la
           vuelve a sacar). */
        if (indice < 0) sinFicha();
        arrancaReloj();
      })
      .catch(function (e) {
        sinFicha();
        if (window.console) console.warn('[hero-lienzo-3d]', e);
      });
  }

  cuandoSobreTiempo(montar);
})();
